export default {
  // Main Menu
  menu: {
    dashboard: "Dashboard",
    liveOps: "Live Operations",
    bookings: "Bookings",
    realRides: "Real Rides",
    routes: "Routes",
    captains: "Captains",
    buses: "Buses",
    users: "Users",
    settings: "Settings",
    logout: "Logout",
    more: "More",
    search: "Search",
    allPages: "All Pages",
    searchPages: "Search pages...",
    companiesWithRoutes: "Registered Companies",
  },

  // General Buttons
  buttons: {
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    add: "Add",
    search: "Search",
    close: "Close",
    back: "Back",
    next: "Next",
    previous: "Previous",
    view: "View",
    details: "Details",
    tripDetails: "Trip Details",
    viewRoute: "View Route",
    confirm: "Confirm",
    clear: "Clear",
    searchInResults: "Search in Results",
    searchInResultsPlaceholder: "Search in results...",
    resetPassword: "Reset Password",
    upload: "Upload",
  },

  // Tables
  table: {
    noData: "No data available",
    loading: "Loading...",
    showing: "Showing",
    to: "to",
    of: "of",
    entries: "entries",
    rowsPerPage: "Rows per page",
    first: "First",
    last: "Last",
    previous: "Previous",
    next: "Next",
    search: "Search",
    searchByName: "Search by name",
    searchByFromArea: "Search by from area",
    searchByToArea: "Search by to area",
    searchByBaseFair: "Search by price",
    searchById: "Search by ID",
    id: "ID",
    icon: "Icon",
    actions: "Actions",
  },

  // Status
  status: {
    active: "Active",
    inactive: "Inactive",
    pending: "Pending",
    completed: "Completed",
    cancelled: "Cancelled",
    running: "Running",
    stopped: "Stopped",
  },

  companyStatus: {
    new: "New",
    underReview: "Under Review",
    approved: "Approved",
    rejected: "Rejected",
  },

  // Messages
  messages: {
    confirm: "Confirm",
    confirmDelete: "Are you sure you want to delete?",
    saveSuccess: "Saved successfully",
    deleteSuccess: "Deleted successfully",
    errorOccurred: "An error occurred",
    noResults: "No results found",
    enterAllData: "Please enter all data first",
    invalidData: "Invalid data",
    done: "Done",
    invalid: "Invalid",
    deleted: "Deleted",
    error: "Error",
    added: "Added",
    edited: "Edited",
    deleted: "Deleted",
    success: "Success",
    warning: "Warning",
  },

  // Common
  common: {
    coordinates: "Coordinates",
    email: "Email",
    admin: "Admin",
  },

  dialogs: {
    deleteConfirm: "Delete Confirmation",
    resetPasswordConfirm: "Reset Password Confirmation",
  },

  corporates: {
    manageEmails: "Manage Emails",
    enterEmail: "Please enter the email",
    addEmailFailed: "Failed to add email.",
    deleteEmailConfirm: "Are you sure you want to delete this email ({email})?",
    deleteEmailFailed: "Failed to delete email.",
    resetPasswordConfirm: "Are you sure you want to reset the password for ({email})?",
    resetPasswordFailed: "Failed to reset password.",
    addTitle: "Add Corporate",
    editTitle: "Edit Corporate",
    name: "Corporate Name",
    address: "Address",
    phones: "Phones",
    enterPhone: "Enter phone number",
    addPhone: "Add Phone",
    uploadLogo: "Upload Logo",
    addCorporate: "Add Corporate",
    saveChanges: "Save Changes",
    title: "Corporates",
    accounts: "Accounts",
    showAllPhones: "Show all phones",
    noCorporates: "No corporates yet.",
    searchByAddress: "Search by address",
  },

  // Language
  language: {
    arabic: "العربية",
    english: "English",
    switchLanguage: "Switch Language",
  },

  companies: {
    title: "Registered Companies",
    name: "Name",
    phone: "Phone",
    email: "Email",
    address: "Address",
    createdAt: "Created At",
    routes: "Routes",
    commercialRegistry: "Commercial Registry",
    taxCard: "Tax Card",
    logo: "Logo",
    from: "From",
    to: "To",
    numberOfLines: "Number of Lines",
    changeStatus: "Change Status",
    notes: "Notes",
    selectStatus: "Select Status",
    updateStatusSuccess: "Status updated successfully",
    updateStatusError: "Error updating status",
  },

  // Users
  users: {
    title: "Users",
    searchByPhoneNumber: "Search by phone number",
    id: "ID",
    name: "Name",
    phone: "Phone",
    email: "Email",
    status: "Status",
    actions: "Actions",
    noUsersYet: "No users yet",
    userDetails: "User Details",
  },

  // Booking Count
  bookingCount: {
    title: "Booking Count",
    rideDate: "Ride Date",
    booking: "Booking",
    noUsers: "No users yet",
    errorInGetData: "Error in get data",
  },

  // Welcome Balance
  welcomeBalance: {
    title: "Welcome Balance Transactions",
    customer: "Customer",
    mobile: "Mobile",
    balance: "Welcome Balance",
    hasWelcome: "Has Welcome",
    lastTransactionDate: "Last Transaction Date",
    addDialogTitle: "Add Welcome Balance Transaction",
    amount: "Amount",
    note: "Note",
    actions: "Actions",
    addEditBalance: "Add / Edit Welcome Balance",
    showUserTransactions: "Show User Transactions",
    userTransactionsTitle: "Transactions for {name}",
  },

  // Corporate Percentages
  corporatePercentage: {
    title: "Corporate Percentages",
    corporate: "Corporate",
    mobile: "Mobile",
    balance: "Balance",
    regoPercentage: "Rego Percentage",
    userPercentage: "User Percentage",
    fromDate: "From Date",
    toDate: "To Date",
    actions: "Actions",
    addDialogTitle: "Add Corporate Percentage",
    amount: "Amount",
    note: "Note",
    addEditPercentage: "Add / Edit Percentage",
    showHistory: "Show History",
    historyTitle: "Percentage History for {name}",
  },

  // Admin Pages
  pages: {
    title: "Pages",
    addNew: "Add Page",
    name: "Name (English)",
    nameAr: "Name (Arabic)",
    route: "Route",
    parentPage: "Parent Page",
    icon: "Icon",
    noPages: "No pages yet.",
    addDialogTitle: "Add Page",
    editDialogTitle: "Edit Page",
    cancel: "Cancel",
    add: "Add",
    edit: "Edit",
  },

  // Booking Details
  bookingDetails: {
    title: "Booking Details",
    selectDate: "Select Date",
    search: "Search",
    customer: "Customer",
    phone: "Phone",
    route: "Route",
    status: "Status",
    pickupStop: "Pickup Stop",
    dropOffStop: "Drop Off Stop",
    rideDate: "Ride Date",
    noBookings: "No bookings yet",
    searchById: "Search by id",
    searchByCustomer: "Search by customer",
    searchByPhone: "Search by phone",
    searchByRoute: "Search by route",
    searchByStatus: "Search by status",
    searchByPickupStop: "Search by pickup stop",
    searchByDropOffStop: "Search by drop off stop",
    chooseRoute: "Choose route",
    chooseStatus: "Choose status",
    promoCode: "Promo Code",
    finalPrice: "Final Price",
  },

  // Bookings
  bookings: {
    title: "Bookings",
    customer: "Customer",
    phone: "Phone",
    bookDate: "Book Date",
    status: "Status",
    route: "Route",
    seats: "Seats",
    rideDate: "Ride Date",
    noBookings: "No bookings yet",
    searchByCustomer: "Search by customer",
    searchByPhone: "Search by phone",
    searchByRoute: "Search by route",
    from: "From",
    to: "To",
    selectCorporate: "Select Corporate",
    pleaseSelectDates:
      "Please select both 'From' and 'To' dates before searching.",
    bookingCancelled: "Booking cancelled successfully",
    failedToCancel: "Failed to cancel booking",
    errorOccurred: "An error occurred while cancelling the booking",
    cancelBookingConfirmation: "Cancel Booking Confirmation",
    areYouSureCancel: "Are you sure you want to cancel this booking?",
    noKeepBooking: "No, Keep Booking",
    yesCancelBooking: "Yes, Cancel Booking",
    thisActionCannotBeUndone: "This action cannot be undone.",
    bookedSeats: "Booked Seats",
    unknownCustomer: "Unknown Customer",
    noSeatNumbers: "No seat numbers available",
    totalSeats: "Total Seats",
    viewSeats: "View seats",
    cancelBooking: "Cancel Booking",
  },

  // Dashboard
  dashboard: {
    bookingSource: "Booking Source",
    dailyBookingSource: "Daily Booking Source",
    monthlyRideStats: "Monthly Ride Stats",
    routeStatistics: "Route Statistics",
    noBookingSourceData: "No booking source data available.",
    noDailyBookingStats: "No daily booking stats available.",
    noMonthlyRideStats: "No monthly ride stats available.",
    noRouteStats: "No route stats found.",
    appBookings: "App Bookings",
    companyBookings: "Company Bookings",
    executed: "Executed",
    cancelled: "Cancelled",
    notExecuted: "Not Executed",
    routeName: "Route Name",
    totalRides: "Total Rides",
    finished: "Finished",
    notStarted: "Not Started",
    inProgress: "In Progress",
    totalBookings: "Total Bookings",
    cancelledBookings: "Cancelled Bookings",
    rideDetailsFor: "Ride Details for",
    rides: "rides",
    noRideDetails:
      "No ride details available for this route in the selected period.",
    loadingRideDetails: "Loading ride details...",
    rideId: "Ride ID",
    captain: "Captain",
    busType: "Bus Type",
    bookings: "Bookings",
    notAssigned: "Not Assigned",
    currentMonthBookings: "Current Month Bookings",
    total: "Total",
    fromUs: "From Us?",
    yes: "Yes",
    no: "No",
    noBookingsFound: "No bookings found.",
    buses: "Buses",
    captains: "Captains",
    routes: "Routes",
    rides: "Rides",
    details: "Details",
    plateNumber: "Plate Number",
    type: "Type",
    captainName: "Captain Name",
    phone: "Phone",
    noBusesFound: "No buses found.",
    noCaptainsFound: "No captains found.",
    noRoutesFound: "No routes found.",
    noRidesFound: "No rides found.",
    loading: "Loading...",
    currentMonthRides: "Current Month Rides",
    start: "Start",
    end: "End",
  },

  // Stop Points
  stops: {
    title: "Stop Points",
    addNew: "Add New Stop Point",
    addTitle: "Add New Stop Point",
    editTitle: "Edit Stop Point",
    viewTitle: "Stop Point View",
    arabicName: "Arabic Name",
    englishName: "English Name",
    status: "Status",
    coordinates: "Coordinates",
    area: "Area",
    id: "ID",
    nameAr: "Name (Arabic)",
    nameEn: "Name (English)",
    clear: "Clear",
    searchById: "Search by ID",
    searchByName: "Search by name",
    searchByArea: "Search by area",
    noStops: "No stops yet",
    selectCorporate: "Select Corporate",
    addSuccess: "Stop point has been added successfully",
    editSuccess: "Stop point has been edited successfully",
    deleteSuccess: "Stop point deleted",
    deleteFailed: "Delete failed",
    enterAllData: "Please enter all data first",
    invalidCoordinates: "Invalid coordinates",
    confirmDelete: "Are you sure you want to delete {name}?",
  },

  // Real Ride Stops
  realRideStops: {
    title: "Trip Stops",
    journeyStops: "Journey Stops",
    arrivalTime: "Arrival Time",
    stationName: "Station Name",
    stationStatus: "Station Status",
    inBus: "In Bus",
    passengersPickedUp: "Passengers Picked Up",
    passengersDroppedOff: "Passengers Dropped Off",
    waiting: "Waiting",
    skipped: "Skipped",
    completed: "Completed",
    arrived: "Arrived",
    busArrived: "Bus Arrived",
    busDeparted: "Bus Departed",
    skipStation: "Skip Station",
    confirmArrival: "Are you sure the bus has arrived?",
    confirmDeparture: "Are you sure the bus has departed?",
    confirmSkip: "Are you sure you want to skip this station?",
    cannotSkipWithPassengers: "Cannot skip this station due to passengers",
    operationSuccess: "Operation completed successfully",
    operationError: "An error occurred",
    unexpectedError: "An unexpected error occurred",
    timeFormat: "Skip Time",
    actualArrivalTime: "Actual Arrival Time",
    departureTime: "Departure Time",
  },

  // Trip Data
  tripData: {
    title: "Trip Details",
    tripInformation: "Trip Information",
    routeName: "Route Name",
    categoryName: "Category Name",
    rideDate: "Ride Date",
    rideTime: "Ride Time",
    arrivalTime: "Arrival Time",
    status: "Status",
    scheduled: "Scheduled",
    started: "Started",
    ended: "Ended",
    cancelled: "Cancelled",
    captainName: "Captain Name",
    busNumber: "Bus Number",
    busType: "Bus Type",
    booking: "Booking",
    noData: "No Data",
    totalPassengers: "Total Passengers",
    totalRevenue: "Total Revenue",
    startTime: "Start Time",
    endTime: "End Time",
    duration: "Duration",
    distance: "Distance",
    notAssigned: "Not Assigned",
    noData: "No Data",
  },

  // Tab Popup
  tabPopup: {
    title: "Trip Details",
    tripDetails: "Trip Details",
    tripInformation: "Trip Information",
    tripStops: "Trip Stops",
    captainInformation: "Captain Information",
    busInfo: "Bus Info",
    route: "Route",
    passengers: "Passengers",
    balance: "Balance",
    changeDate: "Change Date",
    cancelTrip: "Cancel Trip",
    startTrip: "Start Trip",
    endTrip: "End Trip",
    changeCaptain: "Change Captain",
    removeCaptain: "Remove Captain",
    addDeduction: "Add Deduction",
    addBonus: "Add Bonus",
    hideTrip: "Hide Trip",
    showTrip: "Show Trip",
    confirmHideTrip: "Are you sure you want to hide the trip?",
    confirmShowTrip: "Are you sure you want to show the trip?",
    tripCannotStartNow: "The trip cannot begin now",
    tripDoesNotHaveBus: "Trip does not have bus yet",
    tripDoesNotHaveCaptain: "Trip does not have Captain",
    timeDifference: "Time Difference",
    operationCompleted: "Operation completed successfully",
    errorOccurred: "An error occurred",
    enterAllData: "Please enter all data first",
    enterReason: "Please enter reason first",
    startTime: "Start Time",
    endTime: "End Time",
    startReason: "Start Reason",
    endReason: "End Reason",
    note: "Note",
    enterNote: "Enter note...",
    changeBus: "Change Bus",
    addStart: "Add Start",
    addEnd: "Add End",
    editSuccess: "Edit success",
    cancelled: "Cancelled",
    hidden: "Hidden",
    shown: "Shown",
  },

  // Routes
  routes: {
    title: "Routes",
    addNew: "Add New Route",
    addTitle: "Add New Route",
    editTitle: "Edit Route",
    name: "Name",
    baseFair: "Price",
    status: "Status",
    test: "Test",
    fromGovernate: "From Governate",
    toGovernate: "To Governate",
    totalDistance: "Total Distance",
    estimatedTime: "Estimated Time",
    noRoutes: "No routes yet",
    addSuccess: "Route has been added successfully",
    editSuccess: "Route has been edited successfully",
    deleteSuccess: "Route deleted successfully",
    confirmDelete: "Are you sure you want to delete {name}?",
    addStopPoints: "Add Stop Points to",
    routeStops: "Route Stops",
    routePrice: "Route Price",
    routePricing: "Route Pricing",
    available: "Available",
    selected: "Selected",
    sortNum: "Sort Num",
    distance: "Distance",
    time: "Time",
    price: "Price",
    totalDistanceToNext: "Total Distance to Next",
    totalTimeToNext: "Total Time to Next",
    totalPrice: "Total Price",
    noSearchResults: "No Search Users Histories yet",
    selectGovernate: "Select Governate",
    selectArea: "Select Area",
    selectStops: "Select Stops",
    pickup: "Pickup",
    saveStops: "Save Stops",
    stopPointsAdded: "Stop points have been added successfully",
    distanceTimeError: "Couldn't get estimated time and distance",
    atLeastTwoStops: "At least 2 stops are required",
    minutes: "Minutes",
    km: "KM",
    viewRoute: "View Route",
    scheduleRoute: "Schedule Route",
    routeStops: "Route Stops",
    editRoute: "Edit Route",
    deleteRoute: "Delete Route",
    testField: "Test Field",
  },

  // Countries
  countries: {
    title: "Countries",
    addNew: "Add New Country",
    addTitle: "Add New Country",
    editTitle: "Edit Country",
    name: "Country Name",
    showGovernorates: "Show Governorates",
    addSuccess: "Country has been added successfully",
    editSuccess: "Country has been edited successfully",
  },

  // Areas
  areas: {
    title: "Areas",
    addNew: "Add New Area",
    addTitle: "Add New Area",
    editTitle: "Edit Area",
    country: "Country",
    governate: "Governate",
    name: "Area Name",
    addSuccess: "Area has been added successfully",
    editSuccess: "Area has been edited successfully",
  },

  // Governates
  governates: {
    title: "Governates",
    addNew: "Add New Governate",
    addTitle: "Add New Governate",
    editTitle: "Edit Governate",
    country: "Country",
    arabicName: "Arabic Name",
    englishName: "English Name",
    addSuccess: "Governate has been added successfully",
    editSuccess: "Governate has been edited successfully",
  },



  // Route Draw
  routeDraw: {
    addLiveLocation: "Add Live Location To Captain",
    trackLocation: "Track Location",
    location: "Location",
    trackLiveLocationMessage: "Track live location to Captain",
    liveLocationStarted: "Live location tracking started successfully",
    userUnavailable: "User is unavailable",
    liveLocationError: "Failed to start live location tracking",
    noLocationData: "No location data available after multiple attempts",
    locationFetchError: "Failed to fetch location data",
    mapInitError: "Failed to initialize map",
    routeFetchError: "Failed to fetch route data",
    newMessage: "New message received",
    newMessageBody: "You have a new message",
  },

  // Schedules
  schedule: {
    title: "Schedules",
    addNew: "Add New Schedule",
    editTitle: "Edit Schedule",
    startTime: "Start Time",
    busType: "Bus Type",
    arrival: "Arrival",
    departure: "Departure",
    price: "Price",
  priceAfterDiscount: "Price (After Discount)",
    baseFair: "Price",
    status: "Status",
    days: "Days",
    saturday: "Saturday",
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    noSchedules: "No schedules for route {name}",
    addSuccess: "Schedule has been added successfully",
    editSuccess: "Schedule has been edited successfully",
    deleteSuccess: "Schedule deleted successfully",
    confirmDelete: "Are you sure you want to delete this schedule?",
    active: "Active",
    inactive: "Inactive",
    schedules: "Schedules",
    selectCorporate: "Select Corporate",
    actions: "Actions",
    deleteAllScheduledRun: "Delete All Scheduled Runs",
    runAll: "Run All",
    routeName: "Route Name",
    runsPerWeek: "Runs Per Week",
    upComingRuns: "Upcoming Runs",
    lastRun: "Last Run",
    addSchedule: "Add Schedule",
    deleteScheduledRun: "Delete Scheduled Run",
    runSchedule: "Run Schedule",
    viewSchedule: "View Schedule",
    scheduleForRoute: "Schedule for Route",
    atTime: "at Time",
    run: "Run",
    fetchError: "Failed to fetch schedules",
    whenRunSchedule: "When do you want to run the schedule?",
    now: "Now",
    atNight: "At Night",
    confirmDeleteScheduledRun:
      "Are you sure you want to delete this scheduled run?",
    deleteError: "Failed to delete scheduled run",
    runError: "Failed to run schedule",
    forScheduleAt: "for schedule at",
    ofRoute: "of route",
    confirmDeleteAllScheduledRun:
      "Are you sure you want to delete all selected scheduled runs?",
    runScheduleError: "Failed to run schedule",
  },

  // Schedules (plural)
  schedules: {
    title: "Schedules",
    addNew: "Add New Schedule",
    editTitle: "Edit Schedule",
    startTime: "Start Time",
    busType: "Bus Type",
    arrival: "Arrival",
    departure: "Departure",
    price: "Price",
    baseFair: "Price",
    status: "Status",
    days: "Days",
    saturday: "Saturday",
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    noSchedules: "No schedules for route {name}",
    addSuccess: "Schedule has been added successfully",
    editSuccess: "Schedule has been edited successfully",
    deleteSuccess: "Schedule deleted successfully",
    confirmDelete: "Are you sure you want to delete this schedule?",
    active: "Active",
    inactive: "Inactive",
    schedules: "Schedules",
    selectCorporate: "Select Corporate",
    actions: "Actions",
    deleteAllScheduledRun: "Delete All Scheduled Runs",
    runAll: "Run All",
    routeName: "Route Name",
    runsPerWeek: "Runs Per Week",
    upComingRuns: "Upcoming Runs",
    lastRun: "Last Run",
    addSchedule: "Add Schedule",
    deleteScheduledRun: "Delete Scheduled Run",
    runSchedule: "Run Schedule",
    viewSchedule: "View Schedule",
    scheduleForRoute: "Schedule for Route",
    atTime: "at Time",
    run: "Run",
    fetchError: "Failed to fetch schedules",
    whenRunSchedule: "When do you want to run the schedule?",
    now: "Now",
    atNight: "At Night",
    confirmDeleteScheduledRun:
      "Are you sure you want to delete this scheduled run?",
    deleteError: "Failed to delete scheduled run",
    runError: "Failed to run schedule",
    forScheduleAt: "for schedule at",
    ofRoute: "of route",
    confirmDeleteAllScheduledRun:
      "Are you sure you want to delete all selected scheduled runs?",
    runScheduleError: "Failed to run schedule",
  },

  // Buses
  buses: {
    title: "Buses",
    addNew: "Add New Bus",
    addTitle: "Add New Bus",
    editTitle: "Edit Bus",
    status: "Status",
    plateNumber: "Plate Number",
    busType: "Bus Type",
    busColor: "Bus Color",
    busMake: "Bus Make",
    busModel: "Bus Model",
    year: "Year",
    expireLicenseDate: "Expire License Date",
    active: "Active",
    model: "Model",
    make: "Make",
    color: "Color",
    noBuses: "No buses yet",
    addSuccess: "Bus has been added successfully",
    editSuccess: "Bus has been edited successfully",
    deleteSuccess: "Bus deleted successfully",
    confirmDelete: "Are you sure you want to delete bus?",
    uploadFiles: "Upload Files",
    documents: "Documents",
    upload: "Upload",
    delete: "Delete",
    imagePreview: "Image Preview",
    confirmDeleteImage: "Are you sure you want to delete image?",
    uploadSuccess: "File uploaded successfully",
    deleteSuccess: "File deleted successfully",
    selectCorporate: "Select Corporate",
    searchByModel: "Search by model",
    searchByMake: "Search by make",
    searchByYear: "Search by year",
    searchByColor: "Search by color",
    searchByBusType: "Search by bus type",
    searchByBus: "Choose Bus",
    searchByPlateNumber: "Search by plate number",
  },

  // Bus Types
  busTypes: {
    title: "Bus Type",
    addNew: "Add New Bus Type",
    addTitle: "Add New Bus Type",
    editTitle: "Edit Bus Type",
    name: "Name",
    seats: "Seats",
    maxSeats: "Max Seats",
    vehicle: "Vehicle",
    active: "Active",
    noBusTypes: "No busType yet",
    addSuccess: "Bus type has been added successfully",
    editSuccess: "Bus type has been edited successfully",
    deleteSuccess: "Bus type deleted successfully",
    confirmDelete: "Are you sure you want to delete {name}?",
    selectCorporate: "Select Corporate",
    searchByName: "Search by name",
    searchByVehicle: "Search by vehicle",
    searchBySeats: "Search by seats",
    searchByMaxSeats: "Search by max seats",
    manageLayout: "Manage Layout",
    manageFacilities: "Manage Facilities",
    layoutTitle: "Bus Layout",
    facilitiesTitle: "Bus Type Facilities",
    regularSeat: "Regular Seat",
    womanOnly: "Women Only",
    clickToSelect: "Click to select seats, double-click to remove",
    seatSettings: "Seat Settings",
    position: "Position",
    chairLabel: "Chair Label",
    chairLabelHelp: "Custom label for this seat",
    womanOnlySeat: "Women Only",
    selectSeatToEdit: "Select a seat to edit its properties",
    noFacilitiesAssigned: "No facilities assigned to this bus type",
    addNewFacility: "Add New Facility",
    selectFacilityToAdd: "Select a facility to add",
    noMoreFacilities: "No more facilities available to add",
    facilityAdded: "Facility added successfully",
    facilityRemoved: "Facility removed successfully",
    failedToFetchFacilities: "Failed to fetch facilities",
    failedToAddFacility: "Failed to add facility",
    failedToRemoveFacility: "Failed to remove facility",
    cannotSelectMoreSeats: "You cannot select more than {maxSeats} seats.",
  },

  // Colors
  colors: {
    title: "Colors",
    addNew: "Add New Color",
    addTitle: "Add New Color",
    editTitle: "Edit Color",
    name: "Color",
    nameAr: "Name (Arabic)",
    nameEn: "Name (English)",
    noColors: "No color yet",
    addSuccess: "Color has been added successfully",
    editSuccess: "Color has been edited successfully",
    deleteSuccess: "Color deleted successfully",
    confirmDelete: "Are you sure you want to delete {name}?",
    selectCorporate: "Select Corporate",
    searchByName: "Search by name",
  },

  // Doc Names
  docNames: {
    title: "Doc Name",
    addNew: "Add New DocName",
    addTitle: "Add New DocName",
    editTitle: "Edit DocName",
    name: "DocName",
    busCaptain: "Type",
    required: "Required",
    noDocNames: "No DocName yet",
    addSuccess: "DocName has been added successfully",
    editSuccess: "DocName has been edited successfully",
    deleteSuccess: "DocName deleted successfully",
    confirmDelete: "Are you sure you want to delete {name}?",
    selectCorporate: "Select Corporate",
    searchByName: "Search by name",
    captain: "Captain",
    contractor: "Contractor",
    custom: "Custom",
    bus: "Bus",
    employee: "Employee",
  },

  // Makes
  makes: {
    title: "Makes",
    addNew: "Add New Make",
    addTitle: "Add New Make",
    editTitle: "Edit Make",
    name: "Make",
    nameAr: "Name (Arabic)",
    nameEn: "Name (English)",
    noMakes: "No makes yet",
    addSuccess: "Make has been added successfully",
    editSuccess: "Make has been edited successfully",
    deleteSuccess: "Make deleted successfully",
    confirmDelete: "Are you sure you want to delete {name}?",
    selectCorporate: "Select Corporate",
    searchByName: "Search by name",
  },

  // Models
  models: {
    title: "Models",
    addNew: "Add New Model",
    addTitle: "Add New Model",
    editTitle: "Edit Model",
    name: "Model",
    make: "Make",
    noModels: "No Models yet",
    addSuccess: "Model has been added successfully",
    editSuccess: "Model has been edited successfully",
    deleteSuccess: "Model deleted successfully",
    confirmDelete: "Are you sure you want to delete {name}?",
    selectCorporate: "Select Corporate",
    searchByName: "Search by name",
  },

  // Vehicle Types
  vehicleTypes: {
    title: "Vehicle Types",
    addNew: "Add New Vehicle",
    addTitle: "Add New Vehicle",
    editTitle: "Edit Vehicle",
    name: "Vehicle Ar",
    nameEn: "Vehicle En",
    seats: "Seats",
    noVehicleTypes: "No vehicleType yet",
    addSuccess: "Vehicle type has been added successfully",
    editSuccess: "Vehicle type has been edited successfully",
    deleteSuccess: "Vehicle type deleted successfully",
    confirmDelete: "Are you sure you want to delete {name}?",
    selectCorporate: "Select Corporate",
    searchByName: "Search by name",
    searchByNameEn: "Search by English name",
    searchBySeats: "Search by seats",
  },

  // Years
  years: {
    title: "Years",
    addNew: "Add New Year",
    addTitle: "Add New Year",
    editTitle: "Edit Year",
    name: "Year",
    noYears: "No years yet",
    addSuccess: "Year has been added successfully",
    editSuccess: "Year has been edited successfully",
    deleteSuccess: "Year deleted successfully",
    confirmDelete: "Are you sure you want to delete {name}?",
    selectCorporate: "Select Corporate",
    searchByName: "Search by name",
  },

  // Facilities
  facilities: {
    title: "Facilities",
    addNew: "Add New Facility",
    addTitle: "Add New Facility",
    editTitle: "Edit Facility",
    nameAr: "Facility Name (Arabic)",
    nameEn: "Facility Name (English)",
    icon: "Icon",
    image: "Image",
    noFacilities: "No facilities yet",
    addSuccess: "Facility has been added successfully",
    editSuccess: "Facility has been edited successfully",
    deleteSuccess: "Facility deleted successfully",
    confirmDelete: "Are you sure you want to delete {name}?",
    selectCorporate: "Select Corporate",
    searchByName: "Search by name",
    selectIcon: "Select an Icon",
    uploadImage: "Upload Facility Image",
    enterAllData: "Please enter all required data",
  },

  // Cancel Reasons
  cancelReasons: {
    title: "Cancel Reasons",
    addNew: "Add New Cancel Reason",
    addTitle: "Add New Cancel Reason",
    editTitle: "Edit Cancel Reason",
    name: "Cancel Reason",
    noCancelReasons: "No cancel reasons yet",
    addSuccess: "Cancel reason has been added successfully",
    editSuccess: "Cancel reason has been edited successfully",
    deleteSuccess: "Cancel reason deleted successfully",
    confirmDelete: "Are you sure you want to delete {name}?",
    selectCorporate: "Select Corporate",
    searchByName: "Search by name",
  },

  // Ride Categories
  rideCategories: {
    title: "Ride Categories",
    addNew: "Add New Ride Category",
    addTitle: "Add New Ride Category",
    editTitle: "Edit Ride Category",
    name: "Ride Category",
    fare: "Fare",
    noRideCategories: "No ride categories yet",
    addSuccess: "Ride category has been added successfully",
    editSuccess: "Ride category has been edited successfully",
    deleteSuccess: "Ride category deleted successfully",
    confirmDelete: "Are you sure you want to delete {name}?",
    selectCorporate: "Select Corporate",
    searchByName: "Search by name",
    manageFare: "Manage Fare",
    fareTitle: "Ride Category Fare",
    addFare: "Add Fare",
    editFare: "Edit Fare",
    fareSuccess: "Fare has been saved successfully",
  },

  // Deductions
  deductions: {
    title: "Deductions",
    addNew: "Add New Deduction",
    addTitle: "Add New Deduction",
    editTitle: "Edit Deduction",
    name: "Deduction",
    noDeductions: "No deductions yet",
    addSuccess: "Deduction has been added successfully",
    editSuccess: "Deduction has been edited successfully",
    deleteSuccess: "Deduction deleted successfully",
    confirmDelete: "Are you sure you want to delete {name}?",
    selectCorporate: "Select Corporate",
    searchByName: "Search by name",
  },

  // Compensations
  compensations: {
    title: "Compensations",
    addNew: "Add New Compensation",
    addTitle: "Add New Compensation",
    editTitle: "Edit Compensation",
    name: "Compensation",
    noCompensations: "No compensations yet",
    addSuccess: "Compensation has been added successfully",
    editSuccess: "Compensation has been edited successfully",
    deleteSuccess: "Compensation deleted successfully",
    confirmDelete: "Are you sure you want to delete {name}?",
    selectCorporate: "Select Corporate",
    searchByName: "Search by name",
  },

  // Captain Change Reasons
  captainChangeReasons: {
    title: "Captain Change Reasons",
    addNew: "Add New Captain Change Reason",
    addTitle: "Add New Captain Change Reason",
    editTitle: "Edit Captain Change Reason",
    name: "Captain Change Reason",
    noCaptainChangeReasons: "No captain change reasons yet",
    addSuccess: "Captain change reason has been added successfully",
    editSuccess: "Captain change reason has been edited successfully",
    deleteSuccess: "Captain change reason deleted successfully",
    confirmDelete: "Are you sure you want to delete {name}?",
    selectCorporate: "Select Corporate",
    searchByName: "Search by name",
  },

  // Start End Reasons
  startEndReasons: {
    title: "Start End Reasons",
    addNew: "Add New Start End Reason",
    addTitle: "Add New Start End Reason",
    editTitle: "Edit Start End Reason",
    name: "Start End Reason",
    noStartEndReasons: "No start end reasons yet",
    addSuccess: "Start end reason has been added successfully",
    editSuccess: "Start end reason has been edited successfully",
    deleteSuccess: "Start end reason deleted successfully",
    confirmDelete: "Are you sure you want to delete {name}?",
    selectCorporate: "Select Corporate",
    searchByName: "Search by name",
  },

  // User Cancellation Reasons
  userCancellationReasons: {
    title: "User Cancellation Reasons",
    addNew: "Add New User Cancellation Reason",
    addTitle: "Add New User Cancellation Reason",
    editTitle: "Edit User Cancellation Reason",
    name: "User Cancellation Reason",
    noUserCancellationReasons: "No user cancellation reasons yet",
    addSuccess: "User cancellation reason has been added successfully",
    editSuccess: "User cancellation reason has been edited successfully",
    deleteSuccess: "User cancellation reason deleted successfully",
    confirmDelete: "Are you sure you want to delete {name}?",
    selectCorporate: "Select Corporate",
    searchByName: "Search by name",
  },

  // Real Rides
  realRides: {
    title: "Real Rides",
    noRides: "No real Rides yet",
    rideId: "Ride ID",
    rideDate: "Ride Date",
    arrivalTime: "Arrival Time",
    startTime: "Start Time",
    fromStop: "From Stop",
    toStop: "To Stop",
    routeName: "Route Name",
    busType: "Bus Type",
    bus: "Bus",
    busCaptain: "Bus - Captain",
    booking: "Booking",
    status: "Status",
    active: "Active",
    timeLeft: "Time Left",
    tripEnded: "Trip time has ended",
    invalidDate: "Invalid date",
    rideDetails: "Ride Details",
    todayRides: "Today rides",
    rides: "Rides",
    route: "Route",
    dateTime: "Date & Time",
    capacity: "Capacity",
    captainName: "Captain Name",
    busPlate: "Bus plate",
    changeBus: "Change Bus",
    selectNewBus: "Select new bus",
    cancelRide: "Cancel Ride",
    hideRide: "Hide Real Ride",
    showRide: "Show Real Ride",
    confirmHide: "Are you sure you want to hide this ride?",
    confirmShow: "Are you sure you want to show this ride?",
    confirmCancel: "Are you sure you want to cancel this ride?",
    hideSuccess: "Ride hidden successfully",
    showSuccess: "Ride shown successfully",
    cancelSuccess: "Ride cancelled successfully",
    hideFailed: "Failed to hide ride",
    showFailed: "Failed to show ride",
    cancelFailed: "Failed to cancel ride",
    changeReason: "Change Reason",
    note: "Note",
    selectReasonNote: "Please select a reason and enter a note.",
    captain: "Captain",
    contractor: "Contractor",
    name: "Name",
    phone: "Phone",
    phone2: "Phone 2",
    phone3: "Phone 3",
    address: "Address",
    supply: "Supply",
    noCaptain: "No captain yet",
    searchByDate: "Search by date range",
    searchById: "Search",
    searchByRoute: "Search",
    searchByBusType: "Choose Bus Type",
    searchByBus: "Choose Bus",
    searchByBooking: "Search",
    statusActive: "Active",
    statusStarted: "Started",
    statusEnded: "Ended",
    statusHidden: "Hidden",
    statusCancelled: "Cancelled",
    selectCorporate: "Select Corporate",
  },

  // Captains
  captains: {
    title: "Captains",
    addNew: "Add New Captains",
    noCaptains: "No captains yet",
    captainName: "Captain Name",
    captainAddress: "Captain Address",
    nationalID: "National ID",
    invalidNationalID: "Invalid National ID",
    invalidEmail: "Invalid Email",
    gender: "Gender",
    governate: "Governate",
    city: "City",
    religion: "Religion",
    martialStatus: "Martial Status",
    status: "Status",
    active: "Active",
          selectStatus: "Select Status",
            activationTitle: "Captain Activation",
            activate: "Activate",
            noInactiveCaptains: "No inactive captains found",
            confirmActivate: "Are you sure you want to activate this captain?",
          selectCorporate: "Select Corporate",
    uploadFiles: "Upload Captain Files",
    busCaptain: "Bus Captain",
    addBanned: "Add Banned to Captain",
    removeBan: "Remove Ban",
    noBanned: "No banneds yet",
    fromDate: "From Date",
    toDate: "To Date",
    banReason: "Ban Reason",
    allowTime: "Allow Time",
    bannedUser: "Banned User",
    allowUser: "Allow User",
    reason: "Reason",
    confirmRemoveBan: "Are you sure you want to remove ban?",
    addNewBus: "Add New Bus to",
    noBusCaptain: "No Bus Captain yet",
    bus: "Bus",
    confirmRemoveBus:
      "Are you sure you want to take the bus {busName} from captain {captainName}?",
    addNewContractor: "Add New Contractor to",
    noContractor: "No Contractor yet",
    contractor: "Contractor",
    confirmRemoveContractor:
      "Are you sure you want to take the contractor {contractorName} from captain {captainName}?",
    uploadSuccess: "Uploaded successfully",
    deleteSuccess: "Deleted successfully",
    noFiles: "No files available",
    confirmDeleteFile: "Are you sure you want to delete this file?",
    upload: "Upload",
    delete: "Delete",
    newNote: "New Note",
    noNotes: "No Captain Notes yet",
    editNote: "Edit Note",
    addNewNote: "Add New Note",
    positive: "Positive",
    employee: "Employee",
    time: "Time",
    searchById: "Search by ID",
    searchByName: "Search by Name",
    searchByPlate: "Search by Plate Number",
    searchByNationalID: "Search by National ID",
    searchByCity: "Search by City",
    searchByAddress: "Search by Address",
    searchByPhone: "Search by Phone",
    busPlateNumber: "Bus Plate Number",
    banned: "Banned",
    phone1: "Phone 1",
    phone2: "Phone 2",
    phone3: "Phone 3",
    addSuccess: "Added successfully",
    editSuccess: "Edited successfully",
    deleteSuccess: "Deleted successfully",
    enterAllData: "Please enter all required data",
    confirmDelete: "Are you sure you want to delete this captain?",
  },

  // Trip Details
  tripDetails: {
    title: "Trip Details",
    trip: "Trip",
    captain: "Captain",
    bus: "Bus",
    route: "Route",
    passengers: "Passengers",
    stops: "Stops",
    captainBalance: "Captain Balance",
    tripStops: "Trip Stops",
    tripCaptain: "Trip Captain",
    changeTripDate: "Change Trip Date",
    cancelTrip: "Cancel Trip",
    startTrip: "Start Trip",
    endTrip: "End Trip",
    changeCaptain: "Change Captain",
    removeCaptain: "Remove Captain",
    addDeduction: "Add Deduction",
    addBonus: "Add Bonus",
    hideRealRide: "Hide Real Ride",
    showRealRide: "Show Real Ride",
    scheduled: "Scheduled",
    started: "Started",
    ended: "Ended",
    cancelled: "Cancelled",
    notStarted: "Not Started",
    notAssigned: "Not-Assigned",
    at: "at",
    cancel: "Cancel",
    active: "Active",
    inactive: "Inactive",
  },

  // Models
  models: {
    title: "Models",
    addNew: "Add New Model",
    addTitle: "Add Model",
    editTitle: "Edit Model",
    name: "Model Name",
    make: "Make",
    selectCorporate: "Select Corporate",
    addSuccess: "Model added successfully",
    editSuccess: "Model edited successfully",
  },
  // Employees
  employees: {
    title: "Employees",
    personalInfo: "Personal Information",
    contactInfo: "Contact Information",
    addressInfo: "Address Information",
    workInfo: "Work Information",
    corporateEmployees: "Corporate Employees",
    addEmployee: "Add New Employee",
    addNewEmployee: "Add New Employee",
    editEmployee: "Edit Employee",
    employeeName: "Employee Name",
    email: "Email",
    jobTitle: "Job Title",
    searchOrSelectJobTitle: "Search or select job title...",
    other: "Other...",
    typeNewJobTitle: "Type the new job title below",
    backToList: "Back to list",
    typeNewJobTitlePlaceholder: "Type new job title...",
    managePages: "Manage Pages",
    confirmDelete: "Are you sure you want to delete employee {name}?",
    confirmResetPassword: "Are you sure you want to reset password for employee {name}?",
    addedSuccessfully: "Employee added successfully",
    updatedSuccessfully: "Employee updated successfully",
    deletedSuccessfully: "Employee deleted successfully",
    passwordResetSuccessfully: "Password reset successfully",
    failedToAdd: "Failed to add employee",
    failedToUpdate: "Failed to update employee",
    failedToDelete: "Failed to delete employee",
    failedToResetPassword: "Failed to reset password",
    noEmployeesFound: "No employees found",
    noEmployeesFoundMatching: "No employees found matching your criteria",
    userID: "User ID",
    searchByID: "Search by ID",
    searchByName: "Search by name",
    searchByEmail: "Search by email",
    searchByJobTitle: "Search by job title",
    assignPagesToUser: "Assign Pages to User",
    availablePages: "Available Pages",
    userPages: "User Pages",
    pagesUpdatedSuccessfully: "Pages updated successfully",
    failedToUpdatePages: "Failed to update pages",
    addNewEmployees: "Add New Employees",
    employeeNameCol: "Employee name",
    nationalID: "National ID",
    city: "City",
    address: "Address",
    phone1: "Phone1",
    uploadCaptainFiles: "Upload captain Files",
    noEmployeesYet: "No Employees yet.",
    confirmation: "Confirmation",
    confirmDeleteEmployees: "Are you sure you want to delete Employees?",
    phone2: "Phone2",
    phone3: "Phone3",
    gender: "Gender",
    governate: "Governate",
    religine: "Religine",
    martialState: "Martial State",
    group: "Group",
    active: "Active",
    invalidNationalID: "Invalid national ID",
    invalidEmail: "Invalid Email",
    enterAllDataFirst: "Please enter all data first",
    addedSuccessfullyMsg: "Added successfully",
    editSuccessMsg: "Edit success",
    confirmDeleteFile: "Are you sure you want to delete {name}?",
    fileUploadedSuccessfully: "File uploaded successfully",
    fileDeletedSuccessfully: "File deleted successfully",
  },
  // Passengers
  passengers: {
    title: "Passengers",
    customer: "Customer",
    price: "Price",
    code: "Code",
    pickupStop: "Pick Up",
    dropOffStop: "Drop Off",
    seats: "Seats",
    status: "Status",
    phone: "Phone",
    noPassengers: "No Passenger yet.",
    checkIn: "Check In",
    checkOut: "Check Out",
    missing: "Missing",
    cancelTrip: "Cancel Trip",
    changeTrip: "Change Trip",
    addLiveLocation: "Add Live Location",
    checkout: "Checkout",
    checkoutTitle: "Checkout",
    wallet: "Wallet",
    cash: "Cash",
    amount: "Amount",
    theAmount: "The amount",
    tripCost: "Trip cost",
    rest: "Rest",
    addToWallet: "Add to Wallet",
    paid: "It was paid",
    cancelReasons: "Cancel Reasons",
    cancelReasonsTitle: "Cancel Reasons",
    changeReason: "Change Reason",
    note: "Note",
    enterReasonFirst: "enter Reasion first",
    makeCheckIn: "Are you sure you want to check in {name}?",
    makeCheckOut: "Are you sure you want to check out {name}?",
    makeMissing: "Are you sure you want to mark {name} as missing?",
    enterAmount: "enter amount",
    userUnavailable: "user is un avalible",
    editSuccess: "edit success",
  },
  time: {
    days: "d",
    hours: "h",
    minutes: "m",
    seconds: "s",
  },
  // Authentication
  auth: {
    login: "Login",
    email: "Email",
    password: "Password",
    signIn: "Sign In",
    signingIn: "Signing in...",
    required: "Required",
    loginSuccess: "Login successful",
    loginError: "Login error",
    enterEmailPassword: "Please enter your email address and password",
  },
  // Notifications
  notifications: {
    sendNotificationsToUsers: "Send Notifications to Users",
    searchForUser: "Search for user...",
    sendNewNotification: "Send New Notification",
    notificationTitle: "Notification Title",
    notificationTitlePlaceholder: "Notification Title...",
    notificationTitleRequired: "Notification title is required",
    messageBody: "Message Body",
    messageBodyPlaceholder: "Type message body here...",
    messageBodyRequired: "Message body is required",
    send: "Send",
    noUserSelected: "No User Selected",
    selectUserToStart: "Select a user from the sidebar to start sending notifications",
    notificationSent: "Notification sent successfully",
    fillAllFields: "Please fill all required fields",
  },
};
